import React, { Component } from "react";
import _ from 'lodash';
import '../assets/styles/ProfessionalCard.scss';

import { userService} from '../services/user';
import { favouriteService } from '../services/favourite';
import unfav from '../assets/images/fav-unfill.png';
import fav from '../assets/images/fav-fill.png';
import default_avatar from '../assets/images/avatar-default.png';
import location_pin_outline_icon from '../assets/images/location-pin-outline-icon.png';
import mail_icon from '../assets/images/mail_icon_2.png';
import phone_icon from '../assets/images/phone_icon_2.png';
import walk_in_icon from '../assets/images/walk_in_icon.png';
import video_icon from '../assets/images/video_colored_icon.png';
import chat_icon from '../assets/images/chat_icon_dual_color.png';
import { InsuranceRow } from "./InsuranceRow";

export class ProfessionalCard extends Component {

    constructor(props) {
        super(props);

        this.state = {
        };
    }

    onFavClick(location_id, doctor_id, isFav){

        let params = {
            practice_location_id: location_id
        }

        favouriteService.favourite(isFav, params)
        .then(
            data => {
                this.props.onFav(doctor_id, isFav, location_id)
            },
            error => {
                console.log(error)
                this.setState({ error, loading: false })
            }
        );
    }

    isWalkIn(operating_hours){
        let walkIn = _.find(operating_hours, function(day) {
            return (!day.by_appointment_only && day.open_time);
        });
        return walkIn ? true : false
    }

    requestMail = (doctor) => {
        let subject = 'Request for an Appointment';
        let body = `Hi there,%0D%0A%0D%0A I would like to book an appointment with ${doctor.title || ''} ${doctor.name}. Please find my details below: %0D%0A%0D%0A Name: ${userService.getUser().first_name} ${userService.getUser().last_name} %0D%0A Contact Number: ${userService.getUser().phone} %0D%0A Preferred Date %26 Time: %0D%0A%0D%0A Look forward to your return call. Thanks.`;
        return `mailto:care+d${doctor.id}@bookdoc.com?subject=${subject}&body=${body}`
    }

  render() {

      return (
        <div className="prof-card card">
            <div className="card-body">
                {userService.getUser() &&
                    <button className="btn fav-btn" onClick={() => this.onFavClick(this.props.doctor.location.id, this.props.doctor.id,this.props.doctor.favorited)}>
                        { this.props.doctor.favorited ? <img src={fav} alt='favourite' /> : <img src={unfav} alt='unfavourite'/> }
                    </button>
                }
                <div className="prof-details">
                    <div className="profile-pic">
                        <img src={`${this.props.doctor.avatar ? (this.props.doctor.avatar.url.thumb.url) : default_avatar}`} onError={(e) => { e.target.src = default_avatar }} alt='doctor-avatar' />
                        <div className="prof-feature">
                            {this.isWalkIn(this.props.doctor.operating_hours) &&
                                <div className="feature"><img src={walk_in_icon} className="consultation-icon" alt='walk-in' />Walk-in</div>
                            }
                            {(_.has(this.props.doctor, 'chat_enabled') && this.props.doctor.chat_enabled && this.props.doctor.teleconsult_enabled) &&
                                <div className="feature"><img src={chat_icon} className="consultation-icon" alt='chat-img' /> Chat</div>
                            }
                            {(_.has(this.props.doctor, 'video_enabled') && this.props.doctor.video_enabled && this.props.doctor.teleconsult_enabled) &&
                                <div className="feature"><img src={video_icon} className="consultation-icon" alt='consultation'/> Video Call</div>
                            }
                        </div>
                    </div>
                    <div className="details">
                        <div className="name-row">
                            <a className="name" href={`/search-book/professional-profile/${this.props.doctor.friendly_id}/${this.props.doctor.location.friendly_id}`} target="_blank" rel="noreferrer">{this.props.doctor.title || '' } {this.props.doctor.name}</a>
                        </div>
                        {
                            this.props.doctor.specialties.map((specialty, index) => (
                            <div className="specialty" key={`specialty-${index}`}>{specialty.name}</div>
                            ))
                        }
                        <div className="feature-tags">
                            {this.props.doctor.is_using_calendar === true &&
                                <div className="feature-tag online-booking">Online Booking</div>
                            }
                            {(!_.isEmpty(userService.getUser()) && _.includes(this.props.doctor.employer_ids, _.isEmpty(userService.getUser().employee) ? null : userService.getUser().employee.employer_id)) &&
                                <div className="feature-tag corporate-panel">Corporate Panel</div>
                            }
                        </div>
                        <hr className="custom-separator"/>
                        <div className="clinic-row">
                            <img src={location_pin_outline_icon} alt='location-pin-outline' />
                            <a className="clinic-name" href={`/search-book/clinic/${this.props.doctor.location.friendly_id}`}>{this.props.doctor.location.name}</a>
                        </div>
                        <InsuranceRow insurance_ids={this.props.doctor.insurance_ids} insurances={this.props.insurances}/>
                        <div className="contact-container">
                            {this.props.doctor.is_using_calendar === true ?
                                <a className="btn btn-link book-online-btn" href={`/search-book/professional-profile/${this.props.doctor.friendly_id}/${this.props.doctor.location.friendly_id}?is_next=true`}>Book Online</a> : <div></div>
                            }
                            {userService.getUser() &&
                                <div className="phone-email-container">
                                    <a href={`tel:${this.props.doctor.phone_number}`}><img className="contact-icon phone" src={phone_icon} alt='contant-phone'/></a>
                                    <a href={this.requestMail(this.props.doctor)}><img className="contact-icon mail" src={mail_icon} alt='contact-email' /></a>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
      );
  }
}

export default ProfessionalCard;
